<template>
    <div class="card--item">

        <router-link :to="'/sale/product/' + item.slug">
            <div class="image-container">
                <img :src="'https://app.skybase.ru/public/actions/39947490820098?fileid=' + item.code + '-f64'" :alt="'Вы можете купить ' + item.name + ' на сервисе фотопроката MRental'">
            </div>
            <div class="h5 text-center mb-12">{{item.name}}</div>
        </router-link>

        <div>

            <div class="h6 price-box">
                <span class="color-primary">{{item.base_price}} RUB</span>
            </div>

            <div class="text-center">
                <button class="button btn-small" v-on:click="saleClick()">Купить</button>
            </div>
        </div>


    </div>
</template>

<script>
    import store from '../../../services/data';

    export default {
        props: ['item', 'additional'],
        data() {
            return {
                store: store,

            }
        },
        mounted() {

        },

        methods: {
            saleClick() {
                Swal.fire({
                    icon: 'success',
                    title: 'Продажа товара.',
                    html: `Для уточнения деталей и покупки товара свяжитесь с нами по номеру: <a href="tel:+79774097239">+7 977 409 72 39</a>.`,
                });
            }
        }
    }
</script>
